<template>
  <div style="display: flex">
    <a
      v-if="$can('change-setting', 'accounting')"
      class="btn btn-sm btn-clean btn-icon btn-icon-sm"
      @click.prevent="toggleCheck"
      title="تایید تراکنش و به روزرسانی وضعیت آن به موفق"
    >
      <i class="fa fa-check"></i>
    </a>
  </div>
</template>

<script>
import Vue from "vue";
import {accountingService, starShopAccountingService} from "@/common/api.service";
import toastr from "toastr";

export default Vue.extend({
  props: {
    row: {
      required: true,
    },
    index: {
      required: true,
    },
    datatable: {
      required: true,
    },
  },
  computed: {
    activeService() {
      return this.$route.path.includes('pf') ? accountingService : starShopAccountingService;
    },
    toastr() {
      toastr.options = {
        closeButton: true,
        positionClass: "toast-bottom-center",
        preventDuplicates: false,
        rtl: false
      }

      return toastr
    },
  },
  methods: {
    toggleCheck() {
      this.activeService.addToTransactions({hashid: this.row.id, transaction_type: 2 }).then(
        (response) => {
          this.toastr.success(response.data.message);
          this.datatable.reload()
        },
        (error) => {
          this.toastr.error(
            error.response.data.message || i18n.t("message.an_error_occurred")
          );
        }
      );
    },
  },
});
</script>

<style scoped>
.checked {
  color: green;
}
</style>